"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BaseQuestion = _interopRequireDefault(require("./BaseQuestion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class AddressSearchQuestion extends _BaseQuestion.default {
  handleFilters(characteristic, category) {
    if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.filter) === undefined) {
      return;
    }
    const filter = characteristic.filter.map(filterItem => filterItem.replace('{{addressValue}}', `${this.selections[0]}`));
    const characteristicName = this.getCharacteristicName(characteristic);
    this.checkCategory(category);
    if (!this.metadata[category].filters[characteristicName]) {
      this.metadata[category].filters[characteristicName] = [];
    }
    this.metadata[category].filters[characteristicName].push(...filter);
    return this.metadata;
  }
}
exports.default = AddressSearchQuestion;